import Font16 from '@assets/icons/font-16.svg'
import { Icon } from './Icon'

export const Font16Icon = Icon(Font16)
